// Activity types
export const ACTIVITY_TYPES = {
  NOTE: 'NOTE',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

// Activity type filter options
export const ACTIVITY_TYPE_OPTIONS = [
  { value: 'all', label: 'All Types' },
  { value: ACTIVITY_TYPES.NOTE, label: 'Notes' },
  { value: ACTIVITY_TYPES.EMAIL, label: 'Emails' },
  { value: ACTIVITY_TYPES.SMS, label: 'SMS' },
];

// Get activity type color
export const getActivityTypeColor = (type) => {
  const colorMap = {
    [ACTIVITY_TYPES.NOTE]: '#6B7280',
    [ACTIVITY_TYPES.EMAIL]: '#2563EB',
    [ACTIVITY_TYPES.SMS]: '#16A34A',
  };
  return colorMap[type] || '#6B7280';
};

// Get activity type background color
export const getActivityTypeBgColor = (type) => {
  const colorMap = {
    [ACTIVITY_TYPES.NOTE]: '#F3F4F6',
    [ACTIVITY_TYPES.EMAIL]: '#DBEAFE',
    [ACTIVITY_TYPES.SMS]: '#DCFCE7',
  };
  return colorMap[type] || '#F3F4F6';
};

// Channel type options (for communications tab)
export const CHANNEL_TYPE_OPTIONS = [
  { value: 'all', label: 'All Channels' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'SMS', label: 'SMS' },
];

// Status options (for communications tab)
export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'LIVE', label: 'Live' },
  { value: 'HANDOFF', label: 'Handoff' },
  { value: 'CLOSED', label: 'Closed' },
  { value: 'MISSED', label: 'Missed' },
  { value: 'CALLBACK', label: 'Callback' },
];

// Agent filter options (will be populated dynamically)
export const DEFAULT_AGENT_OPTIONS = [
  { value: 'all', label: 'All Agents' },
];

// Category options (for notes tab)
export const CATEGORY_OPTIONS = [
  { value: 'all', label: 'All Categories' },
  { value: 'GENERAL', label: 'General' },
  { value: 'FOLLOW_UP', label: 'Follow Up' },
  { value: 'IMPORTANT', label: 'Important' },
];

// Sort options
export const SORT_OPTIONS = [
  { id: 'last_update', label: 'Last Updated', icon: 'update' },
  { id: 'created_at', label: 'Created Date', icon: 'clock' },
  { id: 'title', label: 'Title (A-Z)', icon: 'sortByAlpha' },
];

// Default pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// View modes
export const VIEW_MODES = {
  LIST: 'list',
  GRID: 'grid',
};
